import { CdkAccordionModule } from "@angular/cdk/accordion";
import { DatePipe, NgClass, NgOptimizedImage } from "@angular/common";
import { Component, inject, input, InputSignal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { CropWithDotsCenterPipe } from "../../../../pipes/crop-with-dots-center.pipe";
import { ReportExposuresComponent } from "../../../report-partial/report-exposures/report-exposures.component";
import {
  ReportIdentificationComponent
} from "../../../report-partial/report-identification/report-identification.component";
import { ReportTriggersComponent } from "../../../report-partial/report-triggers/report-triggers.component";
import { Top10ListComponent } from "./components/top-10-list/top-10-list.component";
import { ReportEntity, Top10Data } from "../../../../../api/api.model";

@Component({
  selector: 'app-top-10-report',
  standalone: true,
  imports: [
    DatePipe,
    NgClass,
    TranslateModule,
    MatIconModule,
    CropWithDotsCenterPipe,
    NgOptimizedImage,
    CdkAccordionModule,
    MatTooltipModule,
    MatButtonModule,
    ReportIdentificationComponent,
    ReportExposuresComponent,
    ReportTriggersComponent,
    MatTabsModule,
    Top10ListComponent,
  ],
  providers: [
    DatePipe
  ],
  templateUrl: './top-10-report.component.html',
  styleUrl: './top-10-report.component.scss',
  host: {
    class: 'px-4 pt-4 flex flex-col',
  }
})
export default class Top10ReportComponent {
  public readonly report: InputSignal<ReportEntity<Top10Data>> = input.required();
  private readonly _datePipe: DatePipe = inject(DatePipe);
  // public period: Signal<string> = computed(() => {
  //   const { data: { planSuggestion: { transfersSpreadDays } } } = this.report();
  //   const { from, to } = calcPeriodByTransfersSpreadDays(transfersSpreadDays);
  //   return `${ this._datePipe.transform(from, 'dd/MM/yyyy') ?? 'Unknown' } - ${ this._datePipe.transform(to, 'dd/MM/yyyy') ?? 'Unknown' } `;
  // });

  ngOnInit(): void {
    console.log(this.report());
  }
}
